import { init, setContext, setUser } from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:created', (vueApp) => {
    init({
      dsn: 'https://30fffc72763044aaa0877dbd1ee83084@o195333.ingest.sentry.io/4504972661358592',
      release: useRuntimeConfig().public.release,
      // app: nuxtApp.vueApp,
      app: vueApp,
      beforeSend(event, hint) {
        console.log('[Sentry] event', event)
        // @ts-expect-error
        console.log('[Sentry] hint', hint, 'hint.originalException.message:', hint?.originalException?.message)

        // @ts-expect-error
        if (hint.originalException?.name === 'FetchError' && hint.originalException?.statusCode < 500) {
          console.log('[Sentry] Skipping event because status code is smaller than 500', event, hint)
          return null
        }
        const ignoreErrorStrings = [
          'Failed to fetch dynamically imported module',
          'Unable to preload ',
          'Importing a module script failed',
          'FetchError:',
          'chrome-extension://',
        ]
        for (const subStr of ignoreErrorStrings) {
          if (
            // @ts-expect-error
            hint.originalException?.message?.includes(subStr) ||
            hint.originalException?.toString()?.includes(subStr)
          ) {
            console.log(`[Sentry] Skipping event because of ${subStr}`, event, hint)
            return null
          }
        }

        try {
          const session = useVisitorSession()
          if (session.loggedIn) {
            const user = session.$state
            const sentryUser = {
              id: String(user.id),
              email: user.email,
            }
            console.log('[Sentry] Setting user context', sentryUser)
            // Sentry.setUser(sentryUser)
            event.user = event.user || {}
            event.user.email = user.email
            event.user.id = String(user.id)
          }
          if (event.exception) {
            console.error(`[Exeption handled by Sentry]: (${hint.originalException})`, { event, hint })
          }
        } catch (e) {
          console.log('[Sentry] Failed to set user context. Skipping extra context.', e)
        }
        // send to Sentry
        return event
      },
    })
  })
  return {
    provide: {
      sentrySetContext: (n, context) => setContext(n, context),
      sentrySetUser: (user) => setUser(user),
      // sentrySetTag: (tagName, value) => setTag(tagName, value),
      // sentryAddBreadcrumb: breadcrumb => addBreadcrumb(breadcrumb),
    },
  }
})
